import React from 'react';
import { Close } from '@carbon/icons-react';
import styles from './Tag.module.scss';
import cx from 'classnames';
import { getAccessibleTagColors } from 'utils/colorUtils';

interface TagProps {
  children: React.ReactNode;
  onClick?: () => void;
  onRemove?: () => void;
  dismissible?: boolean;
  color?: string;
  disabled?: boolean;
  className?: string;
}

const DEFAULT_COLOR = '#e0e0e0';

const Tag: React.FC<TagProps> = ({ 
    children, 
    onClick, 
    onRemove, 
    dismissible = false,
    color,
    disabled = false,
    className,
}) => {
    const palette = getAccessibleTagColors(color ?? DEFAULT_COLOR);
    const title = typeof children === 'string' ? children : undefined;

    const handleClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };

    const handleRemove = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (!disabled && onRemove) {
            onRemove();
        }
    };

    if (!onClick) {
        return (
            <span
                className={cx(
                    styles.tag,
                    disabled && styles.tagDisabled,
                    className,
                )}
                style={{ backgroundColor: palette.backgroundColor }}
                title={title}
            >
                <span className={styles.tagLabel} style={{ color: palette.textColor }}>{children}</span>
                {dismissible && (
                    <button
                        type="button"
                        className={styles.tagClose}
                        onClick={handleRemove}
                        disabled={disabled}
                        aria-label="Usuń tag"
                        style={{ color: palette.textColor }}
                    >
                        <Close size={12} />
                    </button>
                )}
            </span>
        );
    }

    return (
        <button
            type="button"
            className={cx(
                styles.tag,
                styles.tagClickable,
                disabled && styles.tagDisabled,
                className,
            )}
            style={{ backgroundColor: palette.backgroundColor }}
            onClick={handleClick}
            disabled={disabled}
            title={title}
        >
            <span className={styles.tagLabel} style={{ color: palette.textColor }}>{children}</span>
            {dismissible && (
                <button
                    type="button"
                    className={styles.tagClose}
                    onClick={handleRemove}
                    disabled={disabled}
                    style={{ color: palette.textColor }}
                    aria-label="Usuń tag"
                >
                    <Close size={12} />
                </button>
            )}
        </button>
    );
};

export default Tag;
